import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/user-1.jpg'
import _imports_1 from '@/assets/images/user-2.jpg'
import _imports_2 from '@/assets/images/user-3.jpg'


const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_2 = { class: "card-body p-4" }
const _hoisted_3 = {
  class: "tab-content",
  id: "myTabContent3"
}
const _hoisted_4 = {
  class: "tab-pane fade",
  id: "code3-tab-pane",
  role: "tabpanel",
  "aria-labelledby": "code3-tab",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("h4", { class: "fs-18 mb-4" }, "Single User With Badge Example", -1)),
      _cache[4] || (_cache[4] = _createElementVNode("ul", {
        class: "nav nav-tabs mb-4",
        id: "myTab3",
        role: "tablist"
      }, [
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link active",
            id: "preview3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#preview3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "preview3-tab-pane",
            "aria-selected": "true"
          }, " Preview ")
        ]),
        _createElementVNode("li", {
          class: "nav-item",
          role: "presentation"
        }, [
          _createElementVNode("button", {
            class: "nav-link",
            id: "code3-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#code3-tab-pane",
            type: "button",
            role: "tab",
            "aria-controls": "code3-tab-pane",
            "aria-selected": "false"
          }, " Code ")
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "preview3-tab-pane",
          role: "tabpanel",
          "aria-labelledby": "preview3-tab",
          tabindex: "0"
        }, [
          _createElementVNode("div", { class: "d-flex justify-content-between" }, [
            _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled d-flex align-items-center gap-1" }, [
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: "position-relative d-block"
                }, [
                  _createElementVNode("img", {
                    src: _imports_0,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }),
                  _createElementVNode("div", { class: "position-absolute top-0 end-0 p-1 bg-success border border-2 border-white rounded-circle" })
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: "position-relative d-block"
                }, [
                  _createElementVNode("img", {
                    src: _imports_1,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }),
                  _createElementVNode("div", { class: "position-absolute top-0 end-0 p-1 bg-primary border border-2 border-white rounded-circle" })
                ])
              ]),
              _createElementVNode("li", null, [
                _createElementVNode("a", {
                  href: "#",
                  class: "position-relative d-block"
                }, [
                  _createElementVNode("img", {
                    src: _imports_2,
                    class: "wh-40 rounded-circle border border-2 border-color-white",
                    alt: "user"
                  }),
                  _createElementVNode("div", { class: "position-absolute top-0 end-0 p-1 bg-warning border border-2 border-white rounded-circle" })
                ])
              ])
            ]),
            _createElementVNode("a", {
              href: "#",
              class: "btn bg-primary bg-opacity-10 fw-bold fs-14 hover-bg"
            }, [
              _createElementVNode("span", { class: "position-relative top-2" }, "View Details")
            ])
          ])
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary bg-white btn-sm copy-btn position-absolute top-0 end-0",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyCode && _ctx.copyCode(...args)))
          }, " Copy "),
          _cache[1] || (_cache[1] = _createElementVNode("pre", { class: "line-numbers pt-0 pb-0 ps-25 pe-25 mb-0" }, [
            _createTextVNode(""),
            _createElementVNode("code", {
              class: "language-markup",
              id: "basicAlertsCode3"
            }, "\n<div class=\"card bg-white border-0 rounded-3 mb-4\">\n<div class=\"card-body p-4\">\n<h4 class=\"fs-18 mb-4\">Single User With Badge Example</h4>\n\n<div class=\"d-flex justify-content-between\">\n<ul class=\"ps-0 mb-0 list-unstyled d-flex align-items-center gap-1\">\n<li>\n<a href=\"#\" class=\"position-relative d-block\">\n<img src=\"@/assets/images/user-1.jpg\" class=\"wh-40 rounded-circle border border-2 border-color-white\" alt=\"user\">\n<div class=\"position-absolute top-0 end-0 p-1 bg-success border border-2 border-white rounded-circle\"></div>\n</a>\n</li>\n<li>\n<a href=\"#\" class=\"position-relative d-block\">\n<img src=\"@/assets/images/user-2.jpg\" class=\"wh-40 rounded-circle border border-2 border-color-white\" alt=\"user\">\n<div class=\"position-absolute top-0 end-0 p-1 bg-primary border border-2 border-white rounded-circle\"></div>\n</a>\n</li>\n<li>\n<a href=\"#\" class=\"position-relative d-block\">\n<img src=\"@/assets/images/user-3.jpg\" class=\"wh-40 rounded-circle border border-2 border-color-white\" alt=\"user\">\n<div class=\"position-absolute top-0 end-0 p-1 bg-warning border border-2 border-white rounded-circle\"></div>\n</a>\n</li>\n</ul>\n\n<a href=\"#\" class=\"btn bg-primary bg-opacity-10 fw-bold fs-14 hover-bg\">\n<span class=\"position-relative top-2\">View Details</span>\n</a>\n</div>\n</div>\n</div>\n"),
            _createTextVNode("\n")
          ], -1))
        ])
      ])
    ])
  ]))
}